import { TaskStatus } from "pages/vdo-ticket/services/TaskStatus";

export const getValidTaskCompletionData = (taskCompletion, workflowTask) => { 
    return taskCompletion.status !== TaskStatus.INVALID && taskCompletion.workflowTaskId === workflowTask;
}

export const getCompletionData = (taskCompletion) => { 
    if(!taskCompletion || !taskCompletion.completionData) {
        return {};
    }
    return JSON.parse(taskCompletion.completionData);
}

